import styled from "styled-components";

export const Container = styled.div`
  background-color: #f5f5f5;
  height: 100vh;
`;

export const Text = styled.p`
  font-size: 20px;
  line-height: 150%;
  color: #333333;
  font-family: Inter;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: wrap;
  align-items: center;
  justify-content: center;
`;

export const TextGreen = styled.p`
  font-size: 20px;
  line-height: 150%;
  color: #02de7f;
  font-family: Inter;
  margin-left: 8px;
  margin-right: 8px;
`;

export const RowAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PositionButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const GradientPosition = styled.div`
  margin-top: -16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;
`;

export const PositionGreenMark = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
`;

export const Content = styled.div`
  bottom: 0px;
  display: flex;
  flex-direction: row;
  padding-top: 23px;
  flex: 1;
`;

export const ContentRight = styled.div``;

export const ContentLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-top: 20px;
`;

export const PositionLogo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 200px;
`;

export const BottomMarks = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100vw;
  align-items: center;
  justify-content: space-between;
  padding-left: 51px;
  margin-top: -60px;
`;

export const PositionGreenTriangle = styled.div`
  margin-top: 120px;
`;

export const SpaceX = styled.div`
  width: 16px;
`;

export const Margin = styled.div`
  height: 16px;
`;
